import { render } from "./Cube3dView.vue?vue&type=template&id=68c7b738&scoped=true"
import script from "./Cube3dView.vue?vue&type=script&lang=js"
export * from "./Cube3dView.vue?vue&type=script&lang=js"

import "./Cube3dView.vue?vue&type=style&index=0&id=68c7b738&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68c7b738"]])

export default __exports__